import { get } from '../tools/http';

function getAssembledGallery(gallery) {
    if (gallery && gallery[0]) {
        const photos = gallery.countImages || 0;
        const videos = gallery.countVideos || 0;
        const total = photos + videos;
        return {
            ...gallery[0],
            count: gallery.countItems,
            photos,
            videos,
            total,
        };
    }
    return null;
}

export default {
    state: () => ({
        galleries: [],
        currentGallery: {},

        galleryItems: [],
        currentGalleryItem: {},

        currentGalleriesPage: 0,
        galleriesPerPage: 8,
        galleriesPagesCount: 0,

        currentGalleryItemsPage: 0,
        galleryItemsPerPage: 12,
        galleryItemsPagesCount: 0,

        currentGalleryItemOffset: 0,

        isGalleryItemLoading: false,
        galleryBreadcrumbTitle: '',
    }),

    mutations: {
        setGalleries: (state, list) => state.galleries = list,
        setCurrentGallery: (state, item) => state.currentGallery = item,
        setCurrentGalleriesPage: (state, page) => state.currentGalleriesPage = page,
        setGalleriesPagesCount: (state, count) => state.galleriesPagesCount = count,

        setGalleryItems: (state, list) => {
            //сортировка перенесена в вызов на бек
            //list.sort((a, b) => {
            //    console.log(a.sort+":"+b.sort);
            //    if (a.sort > b.sort) {
            //        return 1;
            //    }
            //    if (a.sort < b.sort) {
            //        return -1;
            //    }
            //    return 0;
            //});
            state.galleryItems = list;
        },
        setCurrentGalleryItem: (state, item) => state.currentGalleryItem = item,
        setCurrentGalleryItemsPage: (state, page) => state.currentGalleryItemsPage = page,
        setGalleryItemsPagesCount: (state, count) => state.galleryItemsPagesCount = count,

        setCurrentGalleryItemOffset: (state, offset) => state.currentGalleryItemOffset = offset,

        setGalleryItemLoading: (state, flag) => state.isGalleryItemLoading = flag,
        setGalleryBreadcrumbTitle: (state, flag) => state.galleryBreadcrumbTitle = flag,
    },

    actions: {
        loadGalleries: async (ctx, page) => {
            if (page) {
                if (ctx.state.currentGalleriesPage === page) {
                    return;
                }
                ctx.commit('setCurrentGalleriesPage', page);
            }

            const offset = ctx.state.galleriesPerPage * (ctx.state.currentGalleriesPage - 1);
            const limit = ctx.state.galleriesPerPage;

            const sort = 'sort[0][column]=datetime&sort[0][order]=DESC';
            const q = `limit=${limit}&offset=${offset}&isPublic=true&${sort}`;

            const data = await get('cms', `entity/select/gallery?${q}`);
            let galleries = data && data.list
                ? data.list.reduce((res, el) => {
                    if (el) {
                        const gallery = getAssembledGallery(el);
                        res.push(gallery);
                    }
                    return res;
                }, [])
                : [];

            if (galleries.length === 0 && ctx.state.currentGalleriesPage > 1) {
                ctx.commit('setCurrentGalleriesPage', 1);
                return;
            }

            const pagesCount = Math.ceil(data.count / limit);
            if (pagesCount > 0) {
                ctx.commit('setGalleriesPagesCount', pagesCount);
            }
            ctx.commit('setGalleries', galleries);
        },

        loadGallery: async (ctx, id) => {
            if (ctx.state.currentGallery && parseInt(ctx.state.currentGallery.id) === parseInt(id)) {
                return;
            }
            ctx.commit('setGalleryItemLoading', true);

            const data = await get('cms', `entity/select/gallery?id=${id}`);

            if (data.list.length > 0) {
                ctx.commit('setCurrentGallery', getAssembledGallery(data.list[0]));
                ctx.commit('setGalleryBreadcrumbTitle', data.list[0].title);
            } else {
                ctx.commit('setCurrentGallery', null);
            }
            ctx.commit('setGalleryItemLoading', false);
            return data;
        },

        loadGalleryItems: async (ctx, { id, page }) => {
            if (!id) return;
            ctx.commit('setGalleryItemLoading', true);

            if (page) {
                ctx.commit('setCurrentGalleryItemsPage', page);
            }

            const offset = ctx.state.galleryItemsPerPage * (ctx.state.currentGalleryItemsPage - 1);
            const limit = ctx.state.galleryItemsPerPage;

            ctx.commit('setCurrentGalleryItemOffset', offset);

            const sort = 'sort[0][column]=sort&sort[0][order]=DESC&sort[1][column]=id&sort[1][order]=DESC';
            const q = `limit=${limit}&offset=${offset}&isPublic=true&galleryId=${id}&${sort}`;

            const data = await get('cms', `entity/select/galleryItem?${q}`);
            let galleryItems = data.list;

            if (galleryItems.length === 0 && ctx.state.currentGalleryItemsPage > 1) {
                ctx.commit('setCurrentGalleryItemsPage', 1);
                return;
            }

            const pagesCount = Math.ceil(data.count / limit);
            if (pagesCount > 0) {
                ctx.commit('setGalleryItemsPagesCount', pagesCount);
            }
            ctx.commit('setGalleryItems', galleryItems);
            
            const cg = ctx.state.currentGallery;
            cg.total = data.count;
            ctx.commit('setCurrentGallery', cg);
            ctx.commit('setGalleryItemLoading', false);
        },

        loadGalleryItem: async (ctx, id) => {
            if (ctx.state.currentGallery && parseInt(ctx.state.currentGallery.id) === parseInt(id)) {
                return;
            }

            const data = await get('cms', `entity/select/gallery?id=${id}`);

            if (data.list.length > 0) {
                ctx.commit('setCurrentGalleryItem', data.list[0]);
            } else {
                ctx.commit('setCurrentGalleryItem', null);
            }
        },

        loadPaginatedGalleryItem: async (ctx, {id, offset}) => {
            if (!id) return;

            const ofs = ctx.state.currentGalleryItemOffset + offset;
            if (ofs < 0 || ofs > ctx.state.currentGallery.total - 1) return;
            ctx.commit('setCurrentGalleryItemOffset', ofs);
            ctx.commit('setGalleryItemLoading', true);

            const sort = 'sort[0][column]=sort&sort[0][order]=DESC&sort[1][column]=id&sort[1][order]=DESC';
            const q = `limit=1&offset=${ofs}&isPublic=true&galleryId=${id}&${sort}`;

            const data = await get('cms', `entity/select/galleryItem?${q}`);

            ctx.commit('setGalleryItemLoading', false);

            if (data.list.length > 0) {
                ctx.commit('setCurrentGalleryItem', data.list[0]);
            } else {
                ctx.commit('setCurrentGalleryItem', null);
            }
        },

        resetCurrentGalleryItemOffset: (ctx) => {
            const offset = ctx.state.galleryItemsPerPage * (ctx.state.currentGalleryItemsPage - 1);

            ctx.commit('setCurrentGalleryItemOffset', offset);
        },

        setGalleryBreadcrumb: (ctx, title) => {
            ctx.commit('setGalleryBreadcrumbTitle', title);
        },
    },

    getters: {
        galleries: state => state.galleries,
        currentGallery: state => state.currentGallery,
        currentGalleriesPage: state => state.currentGalleriesPage,
        galleriesPagesCount: state => state.galleriesPagesCount,

        galleryItems: state => state.galleryItems,
        currentGalleryItem: state => state.currentGalleryItem,
        currentGalleryItemsPage: state => state.currentGalleryItemsPage,
        galleryItemsPagesCount: state => state.galleryItemsPagesCount,

        isGalleryItemLoading: state => state.isGalleryItemLoading,
        galleryBreadcrumbTitle: state => state.galleryBreadcrumbTitle,
    },
};
